import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Switcher } from '@lib/components'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './Scope.module.scss'

export type SymbolScope = 'project' | 'library'

type Props = {
  scope: SymbolScope
  libraryTitle: string
  /** The plan has no library: the tab opens the Team upgrade modal instead. */
  locked: boolean
  onChange: (scope: SymbolScope) => void
}

/** Project symbols vs the workspace library, at the top of the symbols tab. */
export const Scope: React.FC<Props> = ({
  scope,
  libraryTitle,
  locked,
  onChange,
}) => {
  const dispatch = useDispatch()

  const onLibraryClick = () => {
    if (locked) {
      sendGtmEvent(GtmTriggerName.UPGRADE_SYMBOLS)

      dispatch(
        openModal({
          modalType: MODAL_UPGRADE_PLAN,
          modalProps: {
            planType: 'team',
            slideType: 'symbols',
          },
        })
      )

      return
    }

    onChange('library')
  }

  const onClick = (index: number) => {
    if (index === 0) {
      onChange('project')
      return
    }

    onLibraryClick()
  }

  return (
    <div className={css.container}>
      <Switcher
        size="small"
        items={[
          { content: 'Project', checked: scope === 'project' },
          {
            content: <span className={css.title}>{libraryTitle}</span>,
            checked: scope === 'library',
          },
        ]}
        onClick={onClick}
      />
    </div>
  )
}
